import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Legacy from "@/pages/Legacy";
import GreenFinance from "@/pages/GreenFinance";
import OperatingModel from "@/pages/OperatingModel";
import RoadmapPage from "@/pages/RoadmapPage";
import LeadershipPage from "@/pages/LeadershipPage";
import Certifications from "@/pages/Certifications";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-bg flex items-center justify-center text-ink/40 font-heading">Checking access…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, wheelMultiplier: 1, touchMultiplier: 1.6 });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/legacy" element={<Legacy />} />
            <Route path="/green-finance" element={<GreenFinance />} />
            <Route path="/operating-model" element={<OperatingModel />} />
            <Route path="/roadmap" element={<RoadmapPage />} />
            <Route path="/leadership" element={<LeadershipPage />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminInbox /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </AuthProvider>
  );
}

export default App;
